var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdPlanPerkPostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#8783d1",
    opacity: 1,
    "data-original": "#a365d9",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b77be",
    d: "m147.347 385.801 125.625 125.625c133.12-8.716 238.462-119.167 239.014-254.362L362.051 107.129z",
    opacity: 1,
    "data-original": "#7847a1",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e9edf0",
    d: "M254.699 385.801H147.347V156.908l25.22-21.166 24.56-28.613h57.572l67.338 139.336z",
    opacity: 1,
    "data-original": "#e9edf0",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8dfe6",
    d: "M254.699 107.129h107.352v278.672H254.699z",
    opacity: 1,
    "data-original": "#d8dfe6",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6d7277",
    d: "M254.699 189.72h-79.473v-15.723h79.473l49.85 7.862z",
    opacity: 1,
    "data-original": "#6d7277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474d52",
    d: "M254.699 173.997h79.473v15.723h-79.473z",
    opacity: 1,
    "data-original": "#474d52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6d7277",
    d: "M254.699 222.531h-79.473v-15.722h79.473l49.85 7.861z",
    opacity: 1,
    "data-original": "#6d7277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474d52",
    d: "M254.699 206.809h79.473v15.723h-79.473z",
    opacity: 1,
    "data-original": "#474d52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6d7277",
    d: "M254.699 255.343h-79.473V239.62h79.473l49.85 7.862z",
    opacity: 1,
    "data-original": "#6d7277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474d52",
    d: "M254.699 239.62h79.473v15.723h-79.473z",
    opacity: 1,
    "data-original": "#474d52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6d7277",
    d: "M254.699 288.155h-79.473v-15.723h79.473l49.85 7.861z",
    opacity: 1,
    "data-original": "#6d7277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474d52",
    d: "M254.699 272.432h79.473v15.723h-79.473z",
    opacity: 1,
    "data-original": "#474d52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6d7277",
    d: "M175.226 308.71h79.473v15.723h-79.473z",
    opacity: 1,
    "data-original": "#6d7277"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M197.127 156.908h-49.78l49.78-49.779z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd428",
    d: "m292.633 314.53 24.768-8.935-7.01-26.372-26.371-7.01-8.936 24.769 2.52 15.028z",
    opacity: 1,
    "data-original": "#ffd428",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef296a",
    d: "m405.558 150.604 33.376 33.376-121.54 121.54-33.376-33.376z",
    opacity: 1,
    "data-original": "#ef296a",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474d52",
    d: "m275.084 296.982-9.903 27.451 27.452-9.903z",
    opacity: 1,
    "data-original": "#474d52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdPlanPerkPostIcon);
export default __webpack_public_path__ + "static/media/ad-plan-perk-post-icon.87148a7d8b40f3cbda77f4ef7ab2e987.svg";
export { ForwardRef as ReactComponent };